export class SaveCurrntTransfrmcacheRequest {
   userID: string;
   orgID: string;
   nodeID: string;
   refineryConfigID: string;
   activeIngestFarmId: string;
   currentTransformerGUID: string;

   constructor(userID: string, orgID: string, nodeID: string, refineryConfigID: string, activeIngestFarmId: string, currentTransformerGUID: string) {
        this.userID = userID;
        this.orgID = orgID;
        this.nodeID = nodeID;
        this.refineryConfigID = refineryConfigID;
        this.activeIngestFarmId = activeIngestFarmId;
        this.currentTransformerGUID = currentTransformerGUID;
   }
}
